import React from 'react';
import { Container, Row, Column, Justify } from '@uds/grid';
import Background, { BackgroundArray } from 'components/common/Background';
import { Alignment } from 'domain/constants/alignment';
import { useBreakpoints } from '@ux/responsive';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

import Body, { OuterProps as BodyProps } from '../Body';
import Scroll from '../Scroll';
import useStylesheet from './Generic.stylesheet';

interface OuterProps extends BodyProps {
  showScroll: boolean;
  background: BackgroundArray;
  onScrollClick: (evt: any) => any;
  hideGradient?: boolean;
}

export const PureBillboardGeneric = ({
  layout,
  colorway,
  hBaseline,
  ctas,
  text,
  additionalText,
  footerText,
  onScrollClick,
  showScroll,
  ribbonId,
  background,
  hideGradient,
}: OuterProps) => {
  const breakpoints = useBreakpoints();
  const { styles } = useStylesheet({
    layout,
    ...breakpoints,
  });
  const alignment = findResponsiveItem(breakpoints, [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);
  const justify = alignment === Alignment.CENTER ? Justify.CENTER : Justify.FLEX_START;
  return (
    <>
      <Background background={background} layout={layout} colorway={colorway} hideGradient={hideGradient} />
      <div style={styles.content}>
        <Container>
          <Row vblock={true} justify={justify}>
            <Column xs={12} md={8} lg={6}>
              <Body
                colorway={colorway}
                ribbonId={ribbonId}
                text={text}
                additionalText={additionalText}
                footerText={footerText}
                ctas={ctas}
                layout={layout}
                hBaseline={hBaseline}
              />
            </Column>
          </Row>
        </Container>
      </div>
      {showScroll && (
        <Container>
          <Scroll onScrollClick={onScrollClick} layout={layout} />
        </Container>
      )}
    </>
  );
};

PureBillboardGeneric.displayName = 'BillboardGeneric';

export default PureBillboardGeneric;
